// extracted by mini-css-extract-plugin
export default {"container":"ShopManagement_container__RShGE","wrapperTag":"ShopManagement_wrapperTag__wF9XD","wrapperInput":"ShopManagement_wrapperInput__7Duop"};